export default "__VITE_ASSET__Cv06Lnsy__"